<template>
    <section class="main-content pb-5">
        <div class="container-fluid">

          <div class="ibox float-e-margins">

              <div class="ibox-title">
                  <h5 style="font-family: 'Kanit', sans-serif; font-size: 20px;" v-html="holding_info.header"></h5>
              </div>
              <div class="ibox-content">

                <div class="alert alert-danger border border-danger text-center">
                    <h1 style="color: #a94442" v-html="holding_info.body"></h1>
                </div>

                <p style="margin: 0cm 0cm 7.5pt;">
                    <span lang="TH"><b>ติดต่อ Call Center</b></span>
                    <br>
                    <span lang="TH"><b>LINE ID : <a :href="line_contact" target="_blank"> <img :src="line_logo" style="height: 24px; "> {{line_name}}</a> </b></span>
                    <br>
                    <br>
                </p>

              </div> <!-- /.ibox-content -->
          </div>

        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex'

//import 'bootstrap/dist/css/bootstrap.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
    name: 'holding',
    data () {
        return {
            line_logo: '',
            site_name: '',
            line_contact: '',
            line_name: '',
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            holding_info: state => state.information.holding_info,
            lineContact: state => state.information.lineContact,
        })
    },
    mounted () {
        this.site_name = process.env.VUE_APP_SITE
        if (this.lineContact.link || this.lineContact.name){
            this.line_contact = this.lineContact.link
            this.line_name = this.lineContact.name
        }
        else {
            this.loadLineContact()
        }
        this.line_logo = require('@/assets/images/'+ 'LINE_APP.png')
    },
    methods: {
        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
                this.line_name = response.name

            } catch (error) {
                console.log('error', error)
            }
        },
    },
}
</script>

<style lang="css" scoped>

th, td {
  padding: 5px;
  text-align: left;
}

.p-sm {
    padding: 15px;
    border: 4px solid #eb1639;
}

.p-sm-gray {
    padding: 15px;
    border: 4px solid #15cbf0;
}

@keyframes fa-blink {
     0% { opacity: 1; }
     25% { opacity: 0.25; }
     50% { opacity: 0.5; }
     75% { opacity: 0.75; }
     100% { opacity: 0; }
 }
.fa-blink {
   -webkit-animation: fa-blink .75s linear infinite;
   -moz-animation: fa-blink .75s linear infinite;
   -ms-animation: fa-blink .75s linear infinite;
   -o-animation: fa-blink .75s linear infinite;
   animation: fa-blink .75s linear infinite;
}

</style>
